import { useContext } from 'react';

import { MFBaseContext } from '../providers/MFBaseProvider';

export const useMFBaseContext = () => {
  const context = useContext(MFBaseContext);

  if (!context) {
    throw new Error('useMFBaseContext must be used within an MFBaseProvider');
  }

  return context;
};
